import CryptoJS from "crypto-js";

// trim a string to a specified length and add an ellipsis if needed
const trimString = (str, wordLimit) => {
  if (str.length > wordLimit) {
    return str.slice(0, wordLimit) + "...";
  }
  return str;
};

// format a number to a locale-specific string representation
const formatNumber = (number) => {
  return number?.toLocaleString("en-US") || "Invalid number";
};

// add double quotes in testimonials description
const addQuotesToDescription = (description) => {
  // Match the content inside the <p> tag
  return description.replace(
    /<p>(.*?)<\/p>/g,
    (match, content) => `<p>" ${content} "</p>`
  );
};

const addQuotesToDescriptionS = (description) => {
  return `"${description}"`;
};

// testimonials rating convert in percentage
const getRatingPercentage = (rating) => (rating / 5) * 100;

// Add double quotes in testimonials description and limit to 50 characters
const addQuotestrimToDescription = (description) => {
  // Match all <p> tags and combine their content
  const combinedContent = Array.from(
    description.matchAll(/<p[^>]*>(.*?)<\/p>/g)
  )
    .map((match) => match[1])
    .join(" ");

  // Add double quotes and limit to 50 characters
  const truncatedContent =
    combinedContent.length > 70
      ? combinedContent.substring(0, 70) + "..."
      : combinedContent;
  return `${truncatedContent}`;
};

// Function to set MainID in localStorage
const setMainID = (MainID) => {
  localStorage.setItem("MainID", MainID);
  return true; // Indicate success
};

// Function to get MainID from localStorage
const getMainID = () => {
  return localStorage.getItem("MainID") || null; // Return null if not found
};

const formatCourseNameForURL = (courseName) => {
  return courseName
    .replace(/[^a-zA-Z0-9\s]/g, "") // Remove special characters
    .replace(/\s+/g, "-") // Replace spaces with hyphens
    .toLowerCase(); // Convert to lowercase
};

const encryptID = (id) => {
  const secretKey = "mySecretKey"; // Use a secure key
  return CryptoJS.AES.encrypt(id.toString(), secretKey).toString();
};

const decryptID = (encryptedID) => {
  const secretKey = "mySecretKey"; // Use the same secure key
  const bytes = CryptoJS.AES.decrypt(encryptedID, secretKey);
  return bytes.toString(CryptoJS.enc.Utf8);
};

const createMarkup = (description) => {
  return { __html: description.replace(/\r\n/g, "<br/>") };
};

// Exporting all utility functions
export {
  trimString,
  formatNumber,
  addQuotesToDescription,
  addQuotesToDescriptionS,
  getRatingPercentage,
  addQuotestrimToDescription,
  setMainID,
  getMainID,
  formatCourseNameForURL,
  encryptID,
  decryptID,
  createMarkup,
};
